import AppHeader from '../AppHeader'

export default {
  name: 'home',
  created () {
    window.sessionStorage.clear()
    this.proposeCount()
  },
  computed: {
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isShopMaster () {
      return this.$store.getters.shopMaster
    },
    isOfficer () {
      return window.localStorage.getItem('is_officer') === '1'
    },
    isHarassment () {
      return window.localStorage.getItem('is_harassment') === '1'
    },
    isHumanStaff () {
      return window.localStorage.getItem('is_human_staff') === '1'
    },
    isMagazineManager () {
      return this.$store.getters.magazineManager
    },
    isClerk () {
      return this.$store.getters.clerk
    },
    isShiftCreator () {
      return this.$store.getters.shiftCreator
    },
    isManagementDept () {
      return window.localStorage.getItem('shop_id') === '725'
    },
    isMachineOrderAdmin () {
      return window.localStorage.getItem('machine_order_type') === 'admin'
    },
    proposeTotalCount () {
      return this.$store.getters.proposeTotalCount
    },
    getShiftCreatorUrl () {
      if (!this.isShopMaster) {
        return '/shift_creators'
      } else {
        return '/shift_creators/' + this.$store.getters.userShopId + '/edit'
      }
    },
    canExportEsMycard () {
      return window.localStorage.getItem('can_export_es_mycard') === '1'
    },
  },
  components: {
    AppHeader
  },
  methods: {
    proposeCount: function() {
      var data = {'status': 'unapproved'}
      this.$store.dispatch('PROPOSE_COUNT', {data: data} )
    },
    willmustPath: function() {
      if (this.isSystemManagement) {
        return '/will_must_admin'
      } else {
        return '/will_must'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/home.js